import { render, staticRenderFns } from "./SaleItemFilters.vue?vue&type=template&id=1b7a6547&"
import script from "./SaleItemFilters.vue?vue&type=script&lang=js&"
export * from "./SaleItemFilters.vue?vue&type=script&lang=js&"
import style0 from "./SaleItemFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports